export const breadcrumbNameMap: Record<string, string> = {
  'expense-manager': 'Expense Manager',
  'automated-tracker': 'Automated Tracker',
  'budget': 'Budget',
  'sandbox': 'Sandbox',
  'redux': 'Redux',
  'graphql': 'GraphQL',
  'settings': 'Settings'
};

export const formatBreadcrumbName = (value: string): string => {
  return breadcrumbNameMap[value] || value.charAt(0).toUpperCase() + value.slice(1);
};
